<div class="folder-dialog-container" data-cy="folder-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="folder-header-section">
      <div class="section-header-title" data-cy="folder-title-text">
        Select Folder
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1;" data-cy="folder-content-section">
      <div *ngIf="FolderTreeData.length > 0 && isFolderPresentation" style="height: 450px; margin-left: 5px;" data-cy="folder-tree-container">
        <tdo-tree #libraryTree 
                  (itemSelected)="onFolderTreeItemSelected($event)"
                  [dataSource]="FolderTreeData"
                  [template]="treeItem"
                  data-cy="folder-tree-component">
          <ng-template #treeItem let-item>
            <div (contextmenu)="onFolderTreeContext($event, item); false"
                 style="display: flex; cursor: pointer; font-size: 14px;"
                 [ngClass]="{'selected-itemRow': isFolderPresentationItemSelected(item)}"
                 data-cy="folder-tree-item">
              <ng-container *ngIf="item.matIconOverride">
                <mat-icon style="color: var(--tdo-secondary); transform: scale(1.5, 1.5); position: relative; top: 3px; left: 3px;" data-cy="folder-delete-icon">delete</mat-icon>
              </ng-container>
              <ng-container *ngIf="!item.matIconOverride">
                <div style="flex-basis: 36px;" *ngIf="!item.isExpanded" data-cy="folder-closed-icon-container">
                  <img style="width: 80%; margin-top: 4px; margin-right: 6px;"
                       src="../../../../assets/Images/image-organizer/icons8-folder-closed-20.svg" alt="Closed Folder Icon"
                       data-cy="folder-closed-icon">
                </div>
                <div style="flex-basis: 36px;" *ngIf="item.isExpanded" data-cy="folder-open-icon-container">
                  <img style="width: 80%; margin-right: 6px; margin-top: 5px;"
                       src="../../../../assets/Images/image-organizer/icons8-folder-opened-20.svg" alt="Opened Folder Icon"
                       data-cy="folder-open-icon">
                </div>
              </ng-container>
              <div style="flex: 1; margin-top: 7px; margin-left: 3px;"
                   [ngClass]="{'selected-item': isFolderPresentationItemSelected(item)}"
                   data-cy="folder-name-text">{{item.name}}</div>
            </div>
          </ng-template>
        </tdo-tree>      
      </div>
      <mat-tab-group *ngIf="!isFolderPresentation" [selectedIndex]="selectedTab" data-cy="folder-tab-group">
      <mat-tab label="Library" data-cy="folder-library-tab">
      <div *ngIf="libraryTreeData.length > 0" style="height: 450px; margin-left: 5px;" data-cy="folder-library-container">
        <tdo-tree #libraryTree 
                  (itemSelected)="onLibraryTreeItemSelected($event)"
                  [dataSource]="libraryTreeData"
                  [template]="treeItem"
                  data-cy="folder-library-tree">
          <ng-template #treeItem let-item>
            <div (contextmenu)="onLibraryTreeContext($event, item); false"
                 style="display: flex; cursor: pointer; font-size: 14px;"
                 data-cy="folder-library-item">
              <ng-container *ngIf="item.matIconOverride">
                <mat-icon style="color: var(--tdo-secondary); transform: scale(1.5, 1.5); position: relative; top: 3px; left: 3px;" data-cy="folder-library-delete-icon">delete</mat-icon>
              </ng-container>
              <ng-container *ngIf="!item.matIconOverride">
                <div style="flex-basis: 36px;" *ngIf="!item.isExpanded" data-cy="folder-library-closed-container">
                  <img style="width: 80%; margin-top: 4px; margin-right: 6px;"
                       src="../../../../assets/Images/image-organizer/icons8-folder-closed-20.svg" alt="Closed Folder Icon"
                       data-cy="folder-library-closed-icon">
                </div>
                <div style="flex-basis: 36px;" *ngIf="item.isExpanded" data-cy="folder-library-open-container">
                  <img style="width: 80%; margin-right: 6px; margin-top: 5px;"
                       src="../../../../assets/Images/image-organizer/icons8-folder-opened-20.svg" alt="Opened Folder Icon"
                       data-cy="folder-library-open-icon">
                </div>
              </ng-container>
              <div style="flex: 1; margin-top: 7px; margin-left: 3px;"
                   [ngClass]="{'selected-item': isItemSelected(item)}"
                   data-cy="folder-library-name-text">{{item.name}}</div>
            </div>
          </ng-template>
        </tdo-tree>
      </div>
    </mat-tab>
    <mat-tab label="Lecture" data-cy="folder-lecture-tab">
      <div *ngIf="lectureTreeData.length > 0" style="height: 450px; margin-left: 5px;" data-cy="folder-lecture-container">
        <tdo-tree #libraryTree 
                  (itemSelected)="onLectureTreeItemSelected($event)"
                  [dataSource]="lectureTreeData"
                  [template]="treeItem"
                  data-cy="folder-lecture-tree">
          <ng-template #treeItem let-item>
            <div (contextmenu)="onLibraryTreeContext($event, item); false"
                 style="display: flex; cursor: pointer; font-size: 14px;"
                 data-cy="folder-lecture-item">
              <ng-container *ngIf="item.matIconOverride">
                <mat-icon style="color: var(--tdo-secondary); transform: scale(1.5, 1.5); position: relative; top: 3px; left: 3px;" data-cy="folder-lecture-delete-icon">delete</mat-icon>
              </ng-container>
              <ng-container *ngIf="!item.matIconOverride">
                <div style="flex-basis: 36px;" *ngIf="!item.isExpanded" data-cy="folder-lecture-closed-container">
                  <img style="width: 80%; margin-top: 4px; margin-right: 6px;"
                       src="../../../../assets/Images/image-organizer/icons8-folder-closed-20.svg" alt="Closed Folder Icon"
                       data-cy="folder-lecture-closed-icon">
                </div>
                <div style="flex-basis: 36px;" *ngIf="item.isExpanded" data-cy="folder-lecture-open-container">
                  <img style="width: 80%; margin-right: 6px; margin-top: 5px;"
                       src="../../../../assets/Images/image-organizer/icons8-folder-opened-20.svg" alt="Opened Folder Icon"
                       data-cy="folder-lecture-open-icon">
                </div>
              </ng-container>
              <div style="flex: 1; margin-top: 7px; margin-left: 3px;"
                   [ngClass]="{'selected-item': isLectureItemSelected(item)}"
                   data-cy="folder-lecture-name-text">{{item.name}}</div>
            </div>
          </ng-template>
        </tdo-tree>
      </div>
    </mat-tab>
  </mat-tab-group>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px;" data-cy="folder-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="folder-cancel-button">Cancel</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="folder-ok-button">Ok</button>
    </div>
  </div>
</div>
